import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {toInt} from '../library/math';

const UseradministrationList            = () => import('../views/useradministration/UseradministrationList.vue');
const UseradministrationModuleAdminList = () => import('../views/useradministration/UseradministrationModuleAdminList.vue');
const UseradministrationPersonView      = () => import('../views/useradministration/person/UseradministrationPersonView.vue');
const UseradministrationPersonEdit      = () => import('../views/useradministration/person/UseradministrationPersonEdit.vue');
const UseradministrationPersonImport    = () => import('../views/useradministration/person/UseradministrationPersonImport.vue');
const UseradministrationRoleView        = () => import('../views/useradministration/role/UseradministrationRoleView.vue');
const UseradministrationRoleEdit        = () => import('../views/useradministration/role/UseradministrationRoleEdit.vue');

const meta: MetaData = {
    module: 'useradministration',
};

let useradministrationRoutes: RouteRecordRaw[] = [

    // list
    {
        name: 'useradministration-list',
        path: '/useradministration/list/:type?',
        component: UseradministrationList,
        meta: meta,
        props(to: RouteLocationStringParam)
        {
            return {
                type: to.params.type,
            };
        },
    },

    // module admin list
    {
        name: 'useradministration-module-admin-list',
        path: '/useradministration/module-admin/list',
        component: UseradministrationModuleAdminList,
        meta: meta,
    },

    // person
    {
        name: 'useradministration-person-view',
        path: '/useradministration/person/view/:id',
        component: UseradministrationPersonView,
        meta: meta,
        props(to: RouteLocationStringParam)
        {
            return {
                id: toInt(to.params.id),
            };
        },
    },
    {
        name: 'useradministration-person-edit',
        path: '/useradministration/person/edit/:id/:employee?',
        component: UseradministrationPersonEdit,
        meta: meta,
        props(to: RouteLocationStringParam)
        {
            return {
                id: toInt(to.params.id),
                employee: toInt(to.params.employee),
            };
        },
    },
    {
        name: 'useradministration-person-add',
        path: '/useradministration/person/add/:id(\\d+)?/:multi(multi)?/:employee(\\d+)?',
        component: UseradministrationPersonEdit,
        meta: meta,
        props(to: RouteLocationStringParam)
        {
            return {
                id: toInt(to.params.id),
                multi: 'multi' === to.params.multi,
                employee: toInt(to.params.employee),
            };
        },
    },
    {
        name: 'useradministration-person-import',
        path: '/useradministration/person/import/',
        component: UseradministrationPersonImport,
        meta: meta,
    },
    // role
    {
        name: 'useradministration-role-view',
        path: '/useradministration/role/view/:id',
        component: UseradministrationRoleView,
        meta: meta,
        props(to: RouteLocationStringParam)
        {
            return {
                id: toInt(to.params.id),
            };
        },
    },
    {
        name: 'useradministration-role-add',
        path: '/useradministration/role/add',
        component: UseradministrationRoleEdit,
        meta: meta,
    },
    {
        name: 'useradministration-role-copy',
        path: '/useradministration/role/copy/:id',
        component: UseradministrationRoleEdit,
        meta: meta,
        props(to: RouteLocationStringParam)
        {
            return {
                id: toInt(to.params.id),
            };
        },
    },
    {
        name: 'useradministration-role-edit',
        path: '/useradministration/role/edit/:id',
        component: UseradministrationRoleEdit,
        meta: meta,
        props(to: RouteLocationStringParam)
        {
            return {
                id: toInt(to.params.id),
            };
        },
    },

    {
        path: '/useradministration',
        redirect: {name: 'useradministration-list'},
    },

    {
        path: '/person/:wildcard*',
        redirect: {name: 'useradministration-list'},
    },

];

export default useradministrationRoutes;